<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage">
<div id="patch">
<img alt="Dead Embers. Matt Brolly" src="media/file2.jpg"/>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?5b180d00